import { Badge, Button, Tooltip, lucideIcons } from '@round/creatorbase-ui';
import { creatorbase } from '@round/api';
import styles from './PoolChips.module.css';

const { XIcon } = lucideIcons;

type Props = {
    pools: creatorbase.Pool[];
    onRemove: (pool: creatorbase.Pool) => void;
};

const PoolChips = ({ pools, onRemove }: Props) => {
    return (
        <div className={styles.chips}>
            {pools.map((pool) => (
                <Tooltip key={pool.id}>
                    {/* asChild makes the badge itself the trigger, rather than Radix wrapping it in
                        a button that would nest inside the remove button's own hit area */}
                    <Tooltip.Trigger asChild>
                        <Badge variant="secondary" className={styles.chip}>
                            {pool.name}
                            <Button
                                variant="bare"
                                size="icon-sm"
                                aria-label={`Remove from ${pool.name}`}
                                className={styles.chipRemove}
                                onClick={() => onRemove(pool)}
                            >
                                <XIcon className={styles.chipRemoveIcon} />
                            </Button>
                        </Badge>
                    </Tooltip.Trigger>

                    <Tooltip.Content>
                        <p className={styles.tooltipDescription}>{pool.description || 'No description'}</p>
                        <p className={styles.tooltipMemberCount}>{pool.member_count} creators</p>
                    </Tooltip.Content>
                </Tooltip>
            ))}
        </div>
    );
};

export default PoolChips;
